export const $ = window.jQuery;
export const gsap = window.gsap;
export const ScrollTrigger = window.ScrollTrigger;
export const SplitText = window.SplitText;
export const Flip = window.Flip;
export const Swiper = window.Swiper;
